import { useState } from "react";

import { InitialPage } from "./InitialPage";

export const Classification = ({ batchData, handleClose }) => {
  const [classification, setClassification] = useState(null);

  return (
    <InitialPage
      classification={classification}
      handleChangeClassification={event =>
        setClassification(event.target.value)
      }
      batchId={batchData.id}
      handleClose={handleClose}
    />
  );
};
